import React, { useState, useEffect, useRef } from 'react';
import api from '../api';
import Layout from '../components/Layout';

export default function LiveTouring() {
  const [ongoingEvents, setOngoingEvents] = useState([]);
  const [selectedId, setSelectedId] = useState('');
  const [checkpoints, setCheckpoints] = useState([]);
  const [photos, setPhotos] = useState([]);
  const [keterangan, setKeterangan] = useState('');
  const [location, setLocation] = useState(null);
  const [locating, setLocating] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [memberId, setMemberId] = useState(null);
  const [rsvpStatus, setRsvpStatus] = useState(null);
  const [starting, setStarting] = useState(false);
  const [joining, setJoining] = useState(false);
  const [finishing, setFinishing] = useState(false);
  const [myActive, setMyActive] = useState(null);
  const [showQuickForm, setShowQuickForm] = useState(false);
  const [quickTitle, setQuickTitle] = useState('');
  const [previewPhoto, setPreviewPhoto] = useState(null);

  // ---- Mode Suara ----
  const [voiceMode, setVoiceMode] = useState(false);
  const [voiceStatus, setVoiceStatus] = useState('');
  const recognitionRef = useRef(null);
  const lastTriggerRef = useRef(0);
  const selectedIdRef = useRef(selectedId);
  useEffect(() => { selectedIdRef.current = selectedId; }, [selectedId]);

  // ---- Kontrol Interkom (tombol play/pause Bluetooth) ----
  const [intercomMode, setIntercomMode] = useState(false);
  const silentAudioRef = useRef(null);
  const SILENCE_DATA_URI = 'data:audio/wav;base64,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';

  const fetchOngoing = async () => {
    setLoading(true);
    try {
      const res = await api.get('/live-touring/');
      setOngoingEvents(res.data);
      if (res.data.length > 0) {
        setSelectedId((prev) => prev || res.data[0].id);
      } else {
        setSelectedId('');
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  const fetchCheckpoints = async (id) => {
    try {
      const res = await api.get(`/live-touring/${id}/checkpoints`);
      setCheckpoints(res.data);
    } catch (err) {
      console.error(err);
    }
  };
  const fetchRsvpStatus = async (id) => {
    try {
      const res = await api.get(`/touring-events/${id}/me`);
      setRsvpStatus(res.data);
    } catch (err) {
      setRsvpStatus(null);
    }
  };
  useEffect(() => {
    api.get('/member-auth/me').then((res) => setMemberId(res.data.id)).catch(() => {});
    fetchOngoing();
    fetchMyActive();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (selectedId) {
      fetchCheckpoints(selectedId);
      fetchRsvpStatus(selectedId);
    }
  }, [selectedId]);

  // Matiin mode suara otomatis kalau keluar halaman
  useEffect(() => {
    return () => {
      if (recognitionRef.current) {
        const r = recognitionRef.current;
        recognitionRef.current = null;
        try { r.stop(); } catch (e) {}
      }
      if (silentAudioRef.current) {
        try { silentAudioRef.current.pause(); } catch (e) {}
      }
      if ('mediaSession' in navigator) {
        try {
          navigator.mediaSession.setActionHandler('play', null);
          navigator.mediaSession.setActionHandler('pause', null);
        } catch (e) {}
      }
    };
  }, []);

  const selectedEvent = ongoingEvents.find((e) => e.id === Number(selectedId));
  const isCreator = selectedEvent && selectedEvent.created_by_member_id === memberId;
  const hasJoined = rsvpStatus && rsvpStatus.ikut === true;

  const fetchMyActive = async () => {
    try {
      const res = await api.get('/touring-events/my-active');
      setMyActive(res.data);
    } catch (err) {
      setMyActive(null);
    }
  };
  const handleQuickStartSubmit = async () => {
    setStarting(true);
    try {
      const res = await api.post('/touring-events/quick-start', { title: quickTitle });
      await fetchOngoing();
      await fetchMyActive();
      setSelectedId(res.data.id);
      setShowQuickForm(false);
      setQuickTitle('');
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal memulai touring');
    } finally {
      setStarting(false);
    }
  };
  const handleJoin = async () => {
    if (!selectedId) return;
    setJoining(true);
    try {
      await api.post(`/touring-events/${selectedId}/rsvp`, { ikut: true });
      await fetchRsvpStatus(selectedId);
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal gabung touring');
    } finally {
      setJoining(false);
    }
  };
  const handleFinishCasual = async () => {
    if (!selectedId) return;
    if (!window.confirm('Selesaikan touring santai ini?')) return;
    setFinishing(true);
    try {
      await api.post(`/touring-events/${selectedId}/finish-casual`);
      await fetchOngoing();
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal menyelesaikan touring');
    } finally {
      setFinishing(false);
    }
  };
  const handleGetLocation = () => {
    if (!navigator.geolocation) {
      alert('Browser tidak mendukung GPS');
      return;
    }
    setLocating(true);
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setLocation({ latitude: pos.coords.latitude, longitude: pos.coords.longitude });
        setLocating(false);
      },
      () => {
        alert('Gagal ambil lokasi. Pastikan GPS/izin lokasi aktif.');
        setLocating(false);
      }
    );
  };
  const handlePhotoSelect = async (e) => {
    const files = Array.from(e.target.files).slice(0, 5);
    if (files.length === 0) return;
    setUploading(true);
    try {
      const urls = [];
      for (const file of files) {
        const fd = new FormData();
        fd.append('photo', file);
        const res = await api.post('/upload/photo', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
        urls.push(res.data.url);
      }
      setPhotos((prev) => [...prev, ...urls].slice(0, 5));
    } catch (err) {
      console.error('Upload photo error:', err);
      const serverMsg = err.response?.data?.error;
      const detail = serverMsg || err.message || 'Tidak diketahui';
      alert(`Gagal upload foto: ${detail}`);
    } finally {
      setUploading(false);
    }
  };
  const handleSubmitCheckpoint = async () => {
    if (!selectedId) return;
    setSubmitting(true);
    try {
      let finalLocation = location;
      if (!finalLocation && navigator.geolocation) {
        try {
          finalLocation = await new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(
              (pos) => resolve({ latitude: pos.coords.latitude, longitude: pos.coords.longitude }),
              () => reject(new Error('GPS gagal diambil otomatis')),
              { timeout: 5000 }
            );
          });
        } catch (gpsErr) {
          console.error('Auto-GPS gagal:', gpsErr.message);
          finalLocation = null;
        }
      }
      await api.post(`/live-touring/${selectedId}/checkpoint`, {
        photos,
        latitude: finalLocation?.latitude || null,
        longitude: finalLocation?.longitude || null,
        keterangan,
      });
      setPhotos([]);
      setKeterangan('');
      setLocation(null);
      fetchCheckpoints(selectedId);
      alert('Checkpoint berhasil diposting!');
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal posting checkpoint');
    } finally {
      setSubmitting(false);
    }
  };

  // ---- Mode Suara: fungsi-fungsi ----
  const speak = (text) => {
    if (!window.speechSynthesis) return;
    try {
      const utter = new SpeechSynthesisUtterance(text);
      utter.lang = 'id-ID';
      window.speechSynthesis.speak(utter);
    } catch (e) { /* ignore */ }
  };

  const submitVoiceCheckpoint = async () => {
    const id = selectedIdRef.current;
    if (!id) return;
    const now = Date.now();
    if (now - lastTriggerRef.current < 8000) return; // cooldown 8 detik, hindari dobel-trigger
    lastTriggerRef.current = now;
    setVoiceStatus('🎤 Terdengar "checkpoint" — mengirim...');
    try {
      let finalLocation = null;
      if (navigator.geolocation) {
        finalLocation = await new Promise((resolve) => {
          navigator.geolocation.getCurrentPosition(
            (pos) => resolve({ latitude: pos.coords.latitude, longitude: pos.coords.longitude }),
            () => resolve(null),
            { timeout: 8000 }
          );
        });
      }
      await api.post(`/live-touring/${id}/checkpoint`, {
        photos: [],
        latitude: finalLocation?.latitude || null,
        longitude: finalLocation?.longitude || null,
        keterangan: 'Checkpoint via suara',
      });
      fetchCheckpoints(id);
      setVoiceStatus('✓ Checkpoint tersimpan');
      speak('Checkpoint tersimpan');
    } catch (err) {
      setVoiceStatus('✗ Gagal kirim checkpoint');
      speak('Gagal kirim checkpoint');
    }
  };

  const startVoiceMode = () => {
    const SpeechRecognitionAPI = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognitionAPI) {
      alert('Browser kamu belum dukung fitur suara. Coba pakai Chrome versi terbaru.');
      return;
    }
    if (!hasJoined) {
      alert('Gabung touring ini dulu sebelum aktifin mode suara.');
      return;
    }

    const recognition = new SpeechRecognitionAPI();
    recognition.lang = 'id-ID';
    recognition.continuous = true;
    recognition.interimResults = false;

    recognition.onresult = (event) => {
      const transcript = event.results[event.results.length - 1][0].transcript.toLowerCase();
      const keywords = ['checkpoint', 'cek poin', 'cek point', 'check in', 'checkin'];
      if (keywords.some((k) => transcript.includes(k))) {
        submitVoiceCheckpoint();
      } else {
        setVoiceStatus(`🎤 Mendengarkan... (terakhir: "${transcript}")`);
      }
    };

    recognition.onerror = (event) => {
      if (event.error !== 'no-speech') {
        console.error('Speech recognition error:', event.error);
      }
    };

    recognition.onend = () => {
      // Chrome suka auto-stop abis jeda diem, restart otomatis selama mode masih aktif
      if (recognitionRef.current) {
        try { recognition.start(); } catch (e) { /* ignore kalau udah jalan */ }
      }
    };

    recognitionRef.current = recognition;
    try {
      recognition.start();
      setVoiceMode(true);
      setVoiceStatus('🎤 Mode suara aktif — bilang "checkpoint" buat nandain lokasi');
      speak('Mode suara aktif');
    } catch (e) {
      alert('Gagal aktifin mode suara. Coba lagi.');
    }
  };

  const stopVoiceMode = () => {
    if (recognitionRef.current) {
      const r = recognitionRef.current;
      recognitionRef.current = null; // null-in dulu biar onend gak auto-restart
      try { r.stop(); } catch (e) { /* ignore */ }
    }
    setVoiceMode(false);
    setVoiceStatus('');
  };

  // ---- Kontrol Interkom: tombol play/pause Bluetooth trigger checkpoint ----
  const startIntercomMode = () => {
    if (!('mediaSession' in navigator)) {
      alert('Browser kamu belum dukung kontrol tombol media Bluetooth. Coba pakai Chrome versi terbaru.');
      return;
    }
    if (!hasJoined) {
      alert('Gabung touring ini dulu sebelum aktifin kontrol interkom.');
      return;
    }

    if (!silentAudioRef.current) {
      const audio = new Audio(SILENCE_DATA_URI);
      audio.loop = true;
      audio.volume = 0.4; // SEMENTARA dinaikin buat diagnostik, nanti diturunin lagi kalau udah kekonfirmasi jalan
      silentAudioRef.current = audio;
    }

    silentAudioRef.current.play().then(() => {
      setVoiceStatus('✓ Audio berhasil diputar (harusnya kedengeran nada pendek)');
    }).catch((playErr) => {
      setVoiceStatus('✗ GAGAL play audio: ' + playErr.name + ' - ' + playErr.message);
      alert('Gagal mulai audio: ' + playErr.name + ' - ' + playErr.message);
      return;
    });

    if (!('mediaSession' in navigator)) {
      setVoiceStatus((prev) => prev + ' | ✗ Browser TIDAK support Media Session API');
      alert('Browser kamu gak support Media Session API sama sekali. Coba update Chrome ke versi terbaru.');
      setIntercomMode(false);
      return;
    }

    try {
      navigator.mediaSession.metadata = new MediaMetadata({
        title: 'Blast Live Touring',
        artist: 'Tekan tombol play/pause interkom buat checkpoint',
      });

      const trigger = () => {
        setVoiceStatus('🎧 Tombol media kedetect! Mengirim checkpoint...');
        submitVoiceCheckpoint();
        if (silentAudioRef.current) {
          silentAudioRef.current.play().catch(() => {});
        }
      };

      navigator.mediaSession.setActionHandler('play', trigger);
      navigator.mediaSession.setActionHandler('pause', trigger);
      navigator.mediaSession.setActionHandler('stop', trigger);
      navigator.mediaSession.setActionHandler('nexttrack', trigger);
      navigator.mediaSession.setActionHandler('previoustrack', trigger);
      navigator.mediaSession.playbackState = 'playing';

      setIntercomMode(true);
    } catch (e) {
      setVoiceStatus('✗ Error Media Session: ' + e.message);
      alert('Error setup Media Session: ' + e.message);
    }
  };

  const stopIntercomMode = () => {
    if (silentAudioRef.current) {
      try { silentAudioRef.current.pause(); } catch (e) {}
    }
    if ('mediaSession' in navigator) {
      try {
        navigator.mediaSession.setActionHandler('play', null);
        navigator.mediaSession.setActionHandler('pause', null);
      } catch (e) {}
    }
    setIntercomMode(false);
    setVoiceStatus('');
  };

  const inputStyle = { background: '#12151A', border: '1px solid #262b33', borderRadius: 6, padding: '10px 12px', color: '#F0EDE4', fontSize: 14, width: '100%' };

  if (loading) return <Layout><p style={{ color: '#8B92A0' }}>Memuat...</p></Layout>;

  return (
    <Layout>
      <h1 style={{ fontSize: 26, fontWeight: 900, fontStyle: 'italic', marginBottom: 20 }}>Live Touring</h1>
      {!myActive && !showQuickForm && (
        <button
          onClick={() => setShowQuickForm(true)}
          style={{ background: '#2B6996', color: '#fff', border: 'none', padding: '12px 22px', borderRadius: 6, fontWeight: 700, cursor: 'pointer', marginBottom: 24 }}
        >
          + Mulai Touring Sekarang
        </button>
      )}
      {myActive && (
        <p style={{ fontSize: 12, color: '#5a616e', marginBottom: 24 }}>Kamu sedang ikut "{myActive.title}". Selesaikan dulu sebelum mulai touring baru.</p>
      )}
      {showQuickForm && (
        <div style={{ background: '#1C2128', border: '1px solid #262b33', borderRadius: 8, padding: 16, marginBottom: 24 }}>
          <label style={{ fontSize: 12, color: '#8B92A0', marginBottom: 6, display: 'block' }}>Nama Touring (cth: "Start Alun-alun - Puncak")</label>
          <input
            type="text"
            value={quickTitle}
            onChange={(e) => setQuickTitle(e.target.value)}
            placeholder="Nama/rute touring..."
            style={{ background: '#12151A', border: '1px solid #262b33', borderRadius: 6, padding: '10px 12px', color: '#F0EDE4', fontSize: 14, width: '100%', marginBottom: 12 }}
          />
          <div style={{ display: 'flex', gap: 10 }}>
            <button
              onClick={handleQuickStartSubmit}
              disabled={starting || !quickTitle.trim()}
              style={{ background: '#D02127', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: 6, fontWeight: 700, cursor: 'pointer' }}
            >
              {starting ? 'Memulai...' : 'Mulai Sekarang'}
            </button>
            <button
              onClick={() => { setShowQuickForm(false); setQuickTitle(''); }}
              style={{ background: 'transparent', border: '1px solid #262b33', color: '#8B92A0', padding: '10px 20px', borderRadius: 6, cursor: 'pointer' }}
            >
              Batal
            </button>
          </div>
        </div>
      )}
      {ongoingEvents.length === 0 ? (
        <p style={{ color: '#8B92A0' }}>Tidak ada touring yang sedang berlangsung saat ini.</p>
      ) : (
        <>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 12, color: '#8B92A0', marginBottom: 4, display: 'block' }}>Pilih Event</label>
            <select value={selectedId} onChange={(e) => setSelectedId(e.target.value)} style={inputStyle}>
              {ongoingEvents.map((ev) => (
                <option key={ev.id} value={ev.id}>{ev.title} {ev.tipe === 'santai' ? '(Santai)' : '(Resmi)'}</option>
              ))}
            </select>
          </div>
          {!hasJoined && (
            myActive && myActive.id !== Number(selectedId) ? (
              <p style={{ fontSize: 12, color: '#5a616e', marginBottom: 20 }}>Kamu sedang ikut touring lain, gak bisa gabung touring ini dulu.</p>
            ) : (
              <button
                onClick={handleJoin}
                disabled={joining}
                style={{ width: '100%', background: '#4ADE80', color: '#12151A', border: 'none', padding: '12px', borderRadius: 6, fontWeight: 800, cursor: 'pointer', marginBottom: 20 }}
              >
                {joining ? 'Bergabung...' : '✓ Gabung Touring Ini'}
              </button>
            )
          )}
          {isCreator && (
            <button
              onClick={handleFinishCasual}
              disabled={finishing}
              style={{ width: '100%', background: 'transparent', border: '1px solid #D02127', color: '#D02127', padding: '10px', borderRadius: 6, fontWeight: 700, cursor: 'pointer', marginBottom: 20 }}
            >
              {finishing ? 'Menyelesaikan...' : 'Selesaikan Touring Ini'}
            </button>
          )}

          {hasJoined && (
            <div style={{
              background: voiceMode ? 'rgba(208,33,39,0.1)' : '#1C2128',
              border: voiceMode ? '1px solid #D02127' : '1px solid #262b33',
              borderRadius: 8, padding: 18, marginBottom: 16,
            }}>
              <p style={{ fontWeight: 700, fontSize: 14, marginBottom: 8 }}>🎤 Mode Suara (Hands-Free)</p>
              <p style={{ fontSize: 12, color: '#8B92A0', marginBottom: 12 }}>
                Aktifin ini, taruh HP di holder, dan bilang <b>"checkpoint"</b> kapan aja buat nandain lokasi tanpa pegang HP. Checkpoint via suara otomatis pakai GPS, tanpa foto.
              </p>
              {voiceStatus && !intercomMode && (
                <p style={{ fontSize: 12, color: voiceMode ? '#D02127' : '#8B92A0', marginBottom: 12, fontWeight: 600 }}>
                  {voiceStatus}
                </p>
              )}
              <button
                onClick={voiceMode ? stopVoiceMode : startVoiceMode}
                disabled={intercomMode}
                style={{
                  background: voiceMode ? '#D02127' : '#2B6996', color: '#fff', border: 'none',
                  padding: '10px 22px', borderRadius: 6, fontWeight: 700, cursor: intercomMode ? 'not-allowed' : 'pointer',
                  opacity: intercomMode ? 0.5 : 1,
                }}
              >
                {voiceMode ? '⏹ Matikan Mode Suara' : '🎤 Aktifkan Mode Suara'}
              </button>
            </div>
          )}

          {hasJoined && (
            <div style={{
              background: intercomMode ? 'rgba(43,105,150,0.1)' : '#1C2128',
              border: intercomMode ? '1px solid #2B6996' : '1px solid #262b33',
              borderRadius: 8, padding: 18, marginBottom: 20,
            }}>
              <p style={{ fontWeight: 700, fontSize: 14, marginBottom: 8 }}>🎧 Kontrol Interkom (Tombol Play/Pause)</p>
              <p style={{ fontSize: 12, color: '#8B92A0', marginBottom: 12 }}>
                Pairing interkom lo ke HP kayak biasa, aktifin ini, terus <b>tekan tombol play/pause di interkom</b> buat nandain checkpoint — gak perlu ngomong apa-apa, jadi gak bakal kepicu obrolan.
              </p>
              <p style={{ fontSize: 11, color: '#5a616e', marginBottom: 12 }}>
                Catatan: kecocokan tergantung merk interkom. Kalau tombolnya gak kedetect, pakai Mode Suara aja sebagai alternatif.
              </p>
              {voiceStatus && intercomMode && (
                <p style={{ fontSize: 12, color: '#2B6996', marginBottom: 12, fontWeight: 600 }}>
                  {voiceStatus}
                </p>
              )}
              <button
                onClick={intercomMode ? stopIntercomMode : startIntercomMode}
                disabled={voiceMode}
                style={{
                  background: intercomMode ? '#D02127' : '#2B6996', color: '#fff', border: 'none',
                  padding: '10px 22px', borderRadius: 6, fontWeight: 700, cursor: voiceMode ? 'not-allowed' : 'pointer',
                  opacity: voiceMode ? 0.5 : 1,
                }}
              >
                {intercomMode ? '⏹ Matikan Kontrol Interkom' : '🎧 Aktifkan Kontrol Interkom'}
              </button>
            </div>
          )}

          <div style={{ background: '#1C2128', border: '1px solid #262b33', borderRadius: 8, padding: 18, marginBottom: 28 }}>
            <p style={{ fontWeight: 700, fontSize: 14, marginBottom: 12 }}>Post Checkpoint Baru (Manual)</p>
            {!hasJoined ? (
              <p style={{ fontSize: 12, color: '#5a616e' }}>Gabung touring ini dulu buat bisa posting checkpoint.</p>
            ) : (
              <>
                <label style={{ fontSize: 12, color: '#8B92A0', marginBottom: 4, display: 'block' }}>Foto (max 5)</label>
                <div style={{ display: 'flex', gap: 10, marginBottom: 10 }}>
                  <label style={{ display: 'inline-block', background: '#D02127', color: '#fff', padding: '8px 16px', borderRadius: 6, fontSize: 12, cursor: 'pointer', fontWeight: 700 }}>
                    {uploading ? '...' : '📷 Ambil Foto'}
                    <input type="file" accept="image/*" capture="environment" onChange={handlePhotoSelect} style={{ display: 'none' }} />
                  </label>
                  <label style={{ display: 'inline-block', background: '#2B6996', color: '#fff', padding: '8px 16px', borderRadius: 6, fontSize: 12, cursor: 'pointer', fontWeight: 700 }}>
                    {uploading ? '...' : 'Pilih dari Galeri'}
                    <input type="file" accept="image/*" multiple onChange={handlePhotoSelect} style={{ display: 'none' }} />
                  </label>
                </div>
                {photos.length > 0 && (
                  <div style={{ display: 'flex', gap: 6, marginBottom: 12, flexWrap: 'wrap' }}>
                    {photos.map((p, i) => (
                      <img key={i} src={p} alt="" style={{ width: 50, height: 50, objectFit: 'cover', borderRadius: 4 }} />
                    ))}
                  </div>
                )}
                <label style={{ fontSize: 12, color: '#8B92A0', marginBottom: 4, display: 'block' }}>Lokasi</label>
                <button
                  onClick={handleGetLocation}
                  style={{ background: 'transparent', border: '1px solid #262b33', color: '#F0EDE4', padding: '8px 14px', borderRadius: 6, fontSize: 12, cursor: 'pointer', marginBottom: 12 }}
                >
                  {locating ? 'Mengambil lokasi...' : location ? `📍 ${location.latitude.toFixed(4)}, ${location.longitude.toFixed(4)}` : '📍 Ambil Lokasi GPS'}
                </button>
                <label style={{ fontSize: 12, color: '#8B92A0', marginBottom: 4, display: 'block' }}>Keterangan</label>
                <textarea
                  value={keterangan}
                  onChange={(e) => setKeterangan(e.target.value)}
                  rows={3}
                  placeholder="Cth: Mulai touring dari titik kumpul"
                  style={{ ...inputStyle, marginBottom: 14 }}
                />
                <button
                  onClick={handleSubmitCheckpoint}
                  disabled={submitting}
                  style={{ background: '#D02127', color: '#fff', border: 'none', padding: '12px 24px', borderRadius: 6, fontWeight: 700, cursor: 'pointer' }}
                >
                  {submitting ? 'Mengirim...' : 'Post Checkpoint'}
                </button>
              </>
            )}
          </div>

          <h2 style={{ fontSize: 18, fontWeight: 800, marginBottom: 14 }}>Riwayat Checkpoint</h2>
          {checkpoints.length === 0 ? (
            <p style={{ color: '#8B92A0', fontSize: 13 }}>Belum ada checkpoint.</p>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {[...checkpoints].reverse().map((c) => (
                <div key={c.id} style={{ background: '#1C2128', border: '1px solid #262b33', borderRadius: 8, padding: 14 }}>
                  <p style={{ color: '#D02127', fontWeight: 700, fontSize: 12 }}>Checkpoint {c.urutan}</p>
                  {c.photos && c.photos.length > 0 && (
                    <div style={{ display: 'flex', gap: 6, marginTop: 8, flexWrap: 'wrap' }}>
                      {c.photos.map((p, i) => (
                        <img
                          key={i}
                          src={p}
                          alt=""
                          onClick={() => setPreviewPhoto(p)}
                          style={{ width: 70, height: 70, objectFit: 'cover', borderRadius: 6, cursor: 'pointer' }}
                        />
                      ))}
                    </div>
                  )}
                  <p style={{ fontSize: 13, marginTop: 8 }}>{c.keterangan || '-'}</p>
                  <p style={{ color: '#8B92A0', fontSize: 11, marginTop: 4 }}>{c.posted_by_name} · {new Date(c.created_at).toLocaleString('id-ID')}</p>
                </div>
              ))}
            </div>
          )}
        </>
      )}
      {previewPhoto && (
        <div
          onClick={() => setPreviewPhoto(null)}
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.9)', zIndex: 100,
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 20,
          }}
        >
          <img
            src={previewPhoto}
            alt=""
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: '100%', maxHeight: '75vh', borderRadius: 8, objectFit: 'contain' }}
          />
          <div style={{ display: 'flex', gap: 12, marginTop: 20 }} onClick={(e) => e.stopPropagation()}>
            <a
              href={`https://ridewithblast.com/api/live-touring/checkpoint-photo/download?url=${encodeURIComponent(previewPhoto)}`}
              style={{ background: '#D02127', color: '#fff', padding: '10px 22px', borderRadius: 6, fontSize: 14, fontWeight: 700, textDecoration: 'none' }}
            >
              ⬇ Unduh
            </a>
            <button
              onClick={() => setPreviewPhoto(null)}
              style={{ background: 'transparent', border: '1px solid #262b33', color: '#F0EDE4', padding: '10px 22px', borderRadius: 6, fontSize: 14, cursor: 'pointer' }}
            >
              Tutup
            </button>
          </div>
        </div>
      )}
    </Layout>
  );
}
